<template>
    <b-card-body class="accordionContent pt-3">
        <div class="card activeCard">
            <div class="container-mars mt-3">
                <div class="card-container">
                    <div class="card-body">
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Shared.Days')"
                                    v-bind:Name="`Days_${index}`"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDayValid"
                                    :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                                    v-model.number="value.day"
                                    v-on:blur="OnBlurDay($event)"
                                    v-on:change="onChangeDay($event)"
                                    v-bind:isReadOnly="frecuencyMode === 'STAT'"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit
                                    v-bind:Label="`${$t('Shared.Dosage')} ${unitOfMeasure}`"
                                    v-bind:Name="`Dosage_${index}`"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDosageValid"
                                    :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                                    v-model.number="value.dosage"
                                    v-on:change="onChangeDosage($event)"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit
                                    v-bind:Label="`${$t('Shared.DailyAmount')} ${unitOfMeasure}`"
                                    v-bind:Name="`DailyAmount_${index}`"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isDailyAmountValid"
                                    :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                                    v-on:change="onChangeDailyAmount($event)"
                                    v-model.number="value.dailyAmount"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Shared.TotalQty')"
                                    v-bind:Name="`totalqty_${index}`"
                                    v-bind:TypeProp="'number'"
                                    v-bind:Min="'1'"
                                    v-bind:Max="'1000'"
                                    v-model.number="value.quantityOrdered"
                                    v-bind:isReadOnly="true"
                                />
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="3" lg="3" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Medication.StartDateAndTime')"
                                    v-bind:Name="`startDateTime_${index}`"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Mask="'##/##/#### ##:## AA'"
                                    v-bind:Min="'1900-01-01'"
                                    v-bind:Max="'2200-12-31'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isStartTimeValid"
                                    v-bind:invalidMessage="startTimeValidMessage"
                                    v-model="startDateTime"
                                    v-on:change="onChangeStartDateTime($event)"
                                    v-on:isValidChange="onIsValidChangeStartDateTime($event)"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdEdit
                                    v-bind:Label="$t('Medication.EndDateAndTime')"
                                    v-bind:Name="`endDateTime_${index}`"
                                    v-bind:TypeProp="'text'"
                                    v-bind:Mask="'##/##/#### ##:## AA'"
                                    v-bind:Min="'1900-01-01'"
                                    v-bind:Max="'2200-12-31'"
                                    v-bind:isRequired="true"
                                    v-bind:isValid="isEndTimeValid"
                                    v-bind:invalidMessage="endTimeValidMessage"
                                    v-model="endDateTime"
                                    v-on:change="onChangeEndDateTime($event)"
                                    v-on:isValidChange="onIsValidChangeEndDateTime($event)"
                                />
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdLookup
                                    v-bind:ModelCode="value.frequencyCode"
                                    v-bind:ModelDescription="value.frequencyDescription"
                                    v-bind:Label="$t('Shared.Frequency')"
                                    v-bind:RefCode="`Frequency_${index}`"
                                    v-bind:AuxFields="FrequencyAuxFields"
                                    v-bind:Api="
                                        'DrugFrequencyHeaders?AdministrationFrequencies=true'
                                    "
                                    v-bind:FieldCode="'code'"
                                    v-bind:isValid="isFrequencyValid"
                                    v-bind:isRequired="true"
                                    v-bind:FieldDescription="'description'"
                                    :InvalidFeedback="TextFrequency"
                                    :SearchTitle="$t('Shared.Frequency')"
                                    :GetValues="onCodeConditionOk"
                                    :SearchFieldCode="'Code'"
                                    v-bind:Fields="BaseFields"
                                />
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdButton
                                    v-bind:Label="$t('Medication.Dosage-Time')"
                                    v-bind:Name="`btn_dosagetime_${index}`"
                                    v-bind:ClassProp="'secondary mt-3 btn-login'"
                                    v-on:click="OpenDosageTime"
                                    v-bind:isReadOnly="
                                        value.frequencyCode &&
                                        (value.dosage || value.dailyAmount) &&
                                        frecuencyMode !== 'STAT' &&
                                        frecuencyMode !== 'PRN'
                                            ? false
                                            : true
                                    "
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Usage')"
                                    v-bind:Options="UsageList"
                                    v-bind:FieldDescription="'name'"
                                    v-bind:FieldCode="'value'"
                                    v-bind:AllowEmpty="false"
                                    v-bind:Model="ModelUsage"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownUsage"
                                />
                            </b-col>
                             <b-col md="3" lg="3" sm="12" v-if="!isNRC">
                                <MdCheckBox
                                    v-bind:Label="$t('Medication.PatientOwned')"
                                    v-bind:Name="`patientowned_${index}`"
                                    v-bind:ClassProp="'AlignCheck'"
                                    v-bind:CheckedValue="true"
                                    v-bind:UncheckedValue="false"
                                    v-model="value.isPatientOwnMedication"
                                    v-on:change="onChangePatientOwned"
                                    v-bind:Tag="'SignMed'"
                                />
                            </b-col>
                        </b-row>

                        <MdTitle
                            v-bind:Text="$t('Shared.Sig')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleSearch'"
                        />
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$tc('Shared.ActionsTxt')"
                                    v-bind:Options="ActionList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelAction"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownAction"
                                    :isValid="isActionValid"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Medication.RouteN')"
                                    v-bind:Options="RouteNameList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelRoute"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownRouteName"
                                    :isValid="isRouteValid"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Medication.When')"
                                    v-bind:Options="WhenList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelWhen"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownWhen"
                                />
                            </b-col>
                            <b-col md="3" lg="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Reason')"
                                    v-bind:Options="ReasonList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelReason"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownReason"
                                    :isValid="isReasonValid"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" lg="12">
                                <MdMemo
                                    v-bind:Name="`textarea_notes_${index}`"
                                    v-bind:Rows="'3'"
                                    v-bind:MaxRows="'6'"
                                    v-bind:MaxLength="'500'"
                                    v-model="value.sig"
                                />
                            </b-col>
                        </b-row>

                        <MdTitle
                            v-bind:Text="$t('Medication.DiagnosisAndIndication')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleSearch'"
                        />
                        <b-row>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Diagnoses')"
                                    v-bind:Options="DiagnosisList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelDiagnosis"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownDiagnosis"
                                    :isValid="isDiagnosisValid"
                                />
                            </b-col>
                            <b-col cols="auto" class="mt-3">
                                <MdButton
                                    v-bind:Label="$t('Medication.AddDiagnoses')"
                                    v-bind:Name="'btn_AddDiag_medicationsProtocol'"
                                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                                    v-on:click="OpenDiagnosis"/>
                            </b-col>
                            <b-col lg="3" md="3" sm="12">
                                <MdSelect
                                    v-bind:Label="$t('Shared.Indications')"
                                    v-bind:Options="IndicationsList"
                                    v-bind:FieldDescription="'description'"
                                    v-bind:FieldCode="'code'"
                                    v-bind:Model="ModelIndication"
                                    v-bind:Multiple="false"
                                    :Input="ChangeDropDownIndication"
                                />
                            </b-col>
                        </b-row>

                        <MdTitle
                            v-bind:Text="$t('Shared.PrescriberNotes')"
                            v-bind:isSubtitle="true"
                            v-bind:Name="'T_TitleSearch'"
                        />
                        <b-row>
                            <b-col md="12" lg="12">
                                <MdMemo
                                    v-bind:Name="`prescriberNotes_${index}`"
                                    v-bind:Rows="'3'"
                                    v-bind:MaxRows="'6'"
                                    v-bind:MaxLength="'500'"
                                    v-model="value.prescriberNotes"
                                />
                            </b-col>
                        </b-row>


                    </div>
                </div>
            </div>
        </div>

        <DiagnosisMainModal v-if="activateModalDiagCodes"
            @getCancel="onCancel($event)"
            @UpdateDiagnosis="UpdateDiag"
            :TitleWindow="'Diagnosis'"
            :ModalId="'ModalIdDiagnosisMedicationsProtocols'"
            :ReadOnly="false"
            :PatientCode="this.$route.params.id">
        </DiagnosisMainModal>

        <ModalDosageTime
            v-bind:marsTimes="marsTimes"
            v-bind:ReadOnly="false"
            v-bind:unitOfMeasure="unitOfMeasure"
            v-bind:DailyAmount="value.dailyAmount"
            @OnModalDosageTimeCancel="HideModalDosageTime"
            @RefreshDosageTime="RefreshDosageTime"
            @DosageDifferent="DosageDifferent"
            v-if="VisibleDosageTime"
            v-bind:ModalId="'modalIdDosageTime'"
            v-bind:TitleWindow="$t('Medication.TitleModalDosageTime')"
        />
    </b-card-body>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';
import MarsService from '@/services/mars.service';
import EnumService from '@/services/enum.service';
import MedicationService from '@/services/medication.service';
import GlobalService from '@/services/global.service';
import Utils from '@/common/utils';
import moment from 'moment';
import { EventBus } from '@/event-bus.js';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'StandingOrderDrug',

    props: {
        value: Object,
        index: Number,
        ActionList: Array,
        RouteNameList: Array,
        WhenList: Array,
        ReasonList: Array,
        DiagnosisList: Array,
        IndicationsList: Array,
        PharmacyOption: Object
    },

    data() {
        return {
            isNRC:this.$store.state.companies.isNRC,
            activateModalDiagCodes:false,
            sliding: null,
            slide: 0,
            isDayValid: true,
            isDosageValid: true,
            isDailyAmountValid: true,
            isStartTimeValid: true,
            isEndTimeValid: true,
            isFrequencyValid: true,
            isDiagnosisValid: true,
            isActionValid: true,
            isRouteValid: true,
            isReasonValid: true,
            VisibleDosageTime: false,
            startTimeValidMessage: null,
            endTimeValidMessage: null,
            listCopyImages: [],
            images: [],
            marsTimes: [],
            UsageList: EnumService.ClinicalMedicationUsage,
            FrequencyAuxFields: ['hoursBetweenDoses', 'mode', 'recurEveryDays', 'timesPerDay'],
            TextFrequency: this.$t('Msg.RequiredField'),
            BaseFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Description') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'mode', sortable: true, label: this.$t('Shared.Mode') },
                { key: 'recurEveryDays', sortable: true, label: this.$t('Shared.ReEveryDays') },
                { key: 'timesPerDay', sortable: true, label: this.$t('Shared.TimesPerDay') },
                {
                    key: 'hoursBetweenDoses',
                    sortable: true,
                    label: this.$t('Shared.HoursBetweenDoses')
                }
            ],
            startDateTime: null,
            endDateTime: null,
            CopyDateTime: null,
            ModelAction: { code: '', description: '' },
            ModelRoute: { code: '', description: '' },
            ModelWhen: { code: '', description: '' },
            ModelReason: { code: '', description: '' },
            ModelDiagnosis: { code: '', description: '' },
            ModelIndication: { code: '', description: '' },
            ModelUsage: { value: '', name: '' },
            MarsAdminTime: [],
            MarsDosage: [],
            timesPerDay: 0,
            DateandTimeUpdated: null,
            frecuencyMode: '',
            pendingChanges: false,
            IsPrescriptionCurrent: false
        };
    },

    computed: {
        unitOfMeasure() {
            return `(${this.value.unitOfMeasure})`;
        }
    },

    methods: {
    UpdateDiag(){
        this.activateModalDiagCodes = false;
        this.$emit('UpdateDiagnosiList');
    },
    onCancel(){
        this.activateModalDiagCodes = false;
    },

    OpenDiagnosis(){
        this.activateModalDiagCodes = true;
    },


        async ImageDrugName() {
            this.images = [];

            if (!this.ContainImageUrl(this.value.drugCode)) {
                this.Load = true;
                await MarsService.getImageByDrug(this.value.drugCode)
                    .then(response => {
                        if (response.status == '200') {
                            this.images = response.data.images;
                            if (!this.ContainImageUrl(this.value.drugCode)) {
                                this.listCopyImages.push({
                                    Code: this.value.drugCode,
                                    images: this.images
                                });
                            }
                        }
                        this.Load = false;
                    })
                    .catch(error => {
                        this.Load = false;
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.images = this.getListImageinCopy(this.value.drugCode);
            }
        },

        async getMarsTimes() {
            await MedicationService.getMarsTimes(
                this.value.frequencyCode,
                this.value.dosage,
                this.value.dailyAmount
            )
                .then(response => {
                    if (response.data) {
                        let marsList = response.data;

                        if (marsList.length > 0) {
                            let arr = [];
                            marsList.forEach(item => {
                                arr.push({
                                    adminTime: Utils.formatTimeHm(item.adminTime),
                                    dosage: item.dosage
                                });
                            });

                            this.marsTimes = arr;
                            this.value.marsTimes = [...marsList];
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getMedSig() {
            EventBus.$emit('ShowWeel', true);
            this.SeparateList();
            let params = {
                DrugCode: this.value.drugCode,
                FreqCode: this.value.frequencyCode,
                Day: this.value.day,
                Dosage: this.value.dosage,
                DailyAmount: this.value.dailyAmount,
                Action: this.ModelAction.code,
                Route: this.ModelRoute.code,
                WhenSig: this.ModelWhen.code,
                Reason: this.ModelReason.code,
                MarsAdminTime: this.MarsAdminTime,
                MarsDosage: this.MarsDosage
            };
            MedicationService.getSig(params)
                .then(response => {
                    if (response.data) {
                        this.value.sig = response.data.toString();
                        this.$emit('input', this.value);
                    }

                    EventBus.$emit('ShowWeel', false);
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false);
                    this.showResponseErrorMessage(error);
                });
        },

        getMedQuantityToOrder() {
            if (Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat())) {
                if (Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())) {
                    EventBus.$emit('ShowWeel', true);
                    this.SeparateList();
                    let params = {
                        DrugCode: this.value.drugCode,
                        FreqCode: this.value.frequencyCode,
                        DailyAmount: this.value.dailyAmount,
                        SDTime: Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                        EDTime: Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                        Day: this.value.day,
                        MarsAdminTime: this.MarsAdminTime,
                        MarsDosage: this.MarsDosage
                    };
                    MedicationService.getQuantityToOrder(params)
                        .then(response => {
                            if (response.status === 200) {
                                this.value.quantityOrdered = response.data;
                                this.$emit('input', this.value);
                            }

                            EventBus.$emit('ShowWeel', false);
                        })
                        .catch(error => {
                            EventBus.$emit('ShowWeel', false);
                            this.showResponseErrorMessage(error);
                        });
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.InvalidDate'), 'error');
                }
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.InvalidDate'), 'error');
            }
        },

        async getMedDrugFrequencyByCode(fCode) {
            EventBus.$emit('ShowWeel', true);
            await MedicationService.getDrugFrequencyByCode(fCode)
                .then(response => {
                    if (response.data) {
                        this.timesPerDay = response.data.timesPerDay;
                    }
                    EventBus.$emit('ShowWeel', false);
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false);
                    this.showResponseErrorMessage(error);
                });
        },

        async getDateTimeUpdate() {
            EventBus.$emit('ShowWeel', true);
            await GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                        this.DateandTimeUpdated = Utils.formatterDateTimeToString(response.data);
                    }
                    EventBus.$emit('ShowWeel', false);
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false);
                    this.showResponseErrorMessage(error);
                });
        },

        async getDateTime(onChangeStopDateTime) {
            EventBus.$emit('ShowWeel', true);
            await GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                        if (onChangeStopDateTime) {
                            this.value.stopDateTime = Utils.formatterDateTimeToString(
                                response.data
                            );
                            this.$emit('input', this.value);
                        } else {
                            this.CopyDateTime = Utils.formatterDateTimeToString(response.data);
                            this.startDateTime = Utils.formatterDateTimeToString(response.data);
                            this.endDateTime = Utils.formatterDateTimeToString(response.data);
                        }
                    }
                    EventBus.$emit('ShowWeel', false);
                })
                .catch(error => {
                    EventBus.$emit('ShowWeel', false);
                    this.showResponseErrorMessage(error);
                });
        },

        async PopulateDatesNotTimed() {
            await this.getDateTimeUpdate();
            let et = this.DateandTimeUpdated ? this.DateandTimeUpdated.split(' ') : null;
            let etime = et !== null ? et[0] + ' 11:59 PM' : this.DateandTimeUpdated;
            this.startDateTime = Utils.formatterDateTimeToString(
                Utils.formatDateTime(this.DateandTimeUpdated, Utils.getDateTimeFormat())
            );
            this.endDateTime = Utils.formatterDateTimeToString(
                Utils.formatDateTime(etime, Utils.getDateTimeFormat())
            );
        },

        SeparateList() {
            this.MarsAdminTime = [];
            this.MarsDosage = [];
            for (var i = 0; i < this.value.marsTimes.length; i++) {
                this.MarsAdminTime.push(this.value.marsTimes[i].adminTime);
                this.MarsDosage.push(this.value.marsTimes[i].dosage);
            }
        },

        ContainImageUrl(Code) {
            for (var i = 0; i < this.listCopyImages.length; i++) {
                if (this.listCopyImages[i].Code === Code) {
                    return true;
                }
            }
            return false;
        },

        getListImageinCopy(Code) {
            for (var i = 0; i < this.listCopyImages.length; i++) {
                if (this.listCopyImages[i].Code === Code) {
                    return this.listCopyImages[i].images;
                }
            }
            return [];
        },

        onSlideStart() {
            this.sliding = true;
        },

        onSlideEnd() {
            this.sliding = false;
        },

        OnBlurDay(item) {
            if (item <= 0) {
                this.value.day = 1;
                this.$emit('input', this.value);
            }
        },

        onChangeDay(item) {
            if (item <= 0) {
                this.value.day = 1;
                this.$emit('input', this.value);
            }

            this.getMedSig();
            if (this.value.day !== 0) {
                if (this.value.day > 0 && this.value.day !== '' && this.value.day !== null) {
                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                    let sDateTime = moment(sDate + ' ' + stime, 'YYYY-MM-DD hh:mm A').add(
                        this.value.day - 1,
                        'd'
                    );
                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
                } else {
                    this.endDateTime = this.startDateTime;
                }
            }

            this.getMedQuantityToOrder();
        },

        async onChangeDosage() {
            this.getMedSig();
            if (this.value.frequencyCode !== null && this.value.frequencyCode !== '') {
                await this.getMedDrugFrequencyByCode(this.value.frequencyCode);
                this.value.dailyAmount = this.value.dosage * this.timesPerDay;
            } else {
                this.value.dailyAmount = 0;
            }

            this.$emit('input', this.value);
            await this.getMarsTimes();
            this.getMedQuantityToOrder();
        },

        async onChangeDailyAmount() {
            this.getMedSig();
            if (this.value.frequencyCode !== null && this.value.frequencyCode !== '') {
                await this.getMedDrugFrequencyByCode(this.value.frequencyCode);
                this.value.dosage = this.value.dailyAmount / this.timesPerDay;
            } else {
                this.value.dosage = 0;
            }

            this.$emit('input', this.value);
            await this.getMarsTimes();
            this.getMedQuantityToOrder();
        },

        OpenDosageTime() {
            this.VisibleDosageTime = true;
        },

        onChangePatientOwned() {},

        async onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('Frequency') >= 0) {
                switch (type) {
                    default:
                        if (result.code) {
                            this.frecuencyMode = result.AuxFields[1];
                            let fCode = result.code.trim();
                            if (result.code.trim() !== this.value.frequencyCode) {
                                if (fCode !== null && fCode !== '') {
                                    await this.getMedDrugFrequencyByCode(fCode);

                                    if (this.value.dailyAmount > 0 && this.value.dosage === 0) {
                                        this.value.dosage =
                                            this.value.dailyAmount / this.timesPerDay;
                                    }

                                    this.value.dailyAmount = this.value.dosage * this.timesPerDay;
                                }
                            }

                            this.value.frequencyCode = result.code.trim();
                            this.value.frequencyDescription = result.description.trim();

                            if (result.AuxFields[1] && result.AuxFields[1] === 'TIMED') {
                                await this.getMarsTimes();
                                if (this.marsTimes.length > 0) {
                                    this.PopulateDatesWithMarsTime(this.marsTimes);
                                }

                                this.getMedQuantityToOrder();
                                this.getMedSig();
                            } else if (result.AuxFields[1] && result.AuxFields[1] === 'STAT') {
                                await this.PopulateDatesNotTimed();
                                this.marsTimes = [];
                                this.value.marsTimes = [];
                                this.value.day = 1;
                                this.onChangeDay(1);
                            } else {
                                this.marsTimes = [];
                                this.value.marsTimes = [];
                                await this.PopulateDatesNotTimed();
                                this.getMedQuantityToOrder();
                                this.getMedSig();
                            }
                        } else {
                            this.value.frequencyCode = '';
                            this.value.frequencyDescription = '';
                        }

                        this.$emit('input', this.value);
                }
            }
        },

        onChangeStartDateTime() {
            if (this.startDateTime && this.endDateTime) {
                if (
                    Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat(), true) &&
                    Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat(), true)
                ) {
                    var date1 = moment(this.startDateTime, Utils.getDateTimeFormat());
                    var date2 = moment(this.endDateTime, Utils.getDateTimeFormat());
                    this.value.day = date2.diff(date1, 'days') + 1;

                    this.$emit('input', this.value);
                    this.getMedQuantityToOrder();
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.InvalidDate'), 'error');
                }
            } else if (
                this.startDateTime &&
                !Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat(), true)
            ) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${this.$t('Shared.InvalidDate')}: ${this.$t('Medication.StartDateAndTime')}`,
                    'error'
                );
            }
        },

        onChangeEndDateTime() {
            if (this.startDateTime && this.endDateTime) {
                if (
                    Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat(), true) &&
                    Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat(), true)
                ) {
                    var date1 = moment(this.startDateTime, Utils.getDateTimeFormat());
                    var date2 = moment(this.endDateTime, Utils.getDateTimeFormat());
                    this.value.day = date2.diff(date1, 'days') + 1;

                    this.$emit('input', this.value);
                    this.getMedQuantityToOrder();
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Shared.InvalidDate'), 'error');
                }
            } else if (
                this.endDateTime &&
                Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat(), true)
            ) {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    `${this.$t('Shared.InvalidDate')}: ${this.$t('Medication.EndDateAndTime')}`,
                    'error'
                );
            }
        },

        ChangeDropDownUsage(item) {
            if (item !== null) {
                this.value.usage = item.value;
            } else {
                this.value.usage = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownDiagnosis(item) {
            if (item !== null) {
                this.ModelDiagnosis = item;
                this.value.diagCode = item.code;
            } else {
                this.ModelDiagnosis = { code: '', description: '' };
                this.value.diagCode = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownIndication(item) {
            if (item !== null) {
                this.ModelIndication = item;
                this.value.indicationCode = item.code;
            } else {
                this.ModelIndication = { code: '', description: '' };
                this.value.indicationCode = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownAction(item) {
            if (item !== null) {
                this.ModelAction = item;
                this.value.actionCode = item.code;
                this.getMedSig();
            } else {
                this.ModelAction = { code: '', description: '' };
                this.value.actionCode = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownRouteName(item) {
            if (item !== null) {
                this.ModelRoute = item;
                this.value.routeCode = item.code;
                this.getMedSig();
            } else {
                this.ModelRoute = { code: '', description: '' };
                this.value.routeCode = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownWhen(item) {
            if (item !== null) {
                this.ModelWhen = item;
                this.value.whenSigCode = item.code;
                this.getMedSig();
            } else {
                this.ModelWhen = { code: '', description: '' };
                this.value.whenSigCode = '';
            }

            this.$emit('input', this.value);
        },

        ChangeDropDownReason(item) {
            if (item !== null) {
                this.ModelReason = item;
                this.value.reasonCode = item.code;
                this.getMedSig();
            } else {
                this.ModelReason = { code: '', description: '' };
                this.value.reasonCode = '';
            }

            this.$emit('input', this.value);
        },

        HideModalDosageTime() {
            this.VisibleDosageTime = false;
        },

        async RefreshDosageTime(obj) {
            this.value.marsTimes = obj.marsTimes;
            this.VisibleDosageTime = false;

            await this.getDateTimeUpdate();
            let sDate = Utils.formatterDate(this.DateandTimeUpdated, Utils.getShortDateFormat());
            let sDateTime = moment(sDate + ' ' + obj.EndDateTime, 'YYYY-MM-DD hh:mm A');

            this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
        },

        DosageDifferent(i) {
            this.value.dosage = i ? 0 : this.value.dosage;
            this.$emit('input', this.value);
        },

        async PopulateDatesWithMarsTime(arr) {
            await this.getDateTimeUpdate();

            let hourNow = Utils.formatTime(this.DateandTimeUpdated, Utils.getDateTimeFormat());
            let _starttime = hourNow;
            let _endtime = '';
            for (const time of arr) {
                if (moment(hourNow, 'hh:mm A') < moment(time.adminTime, 'HH:mm')) {
                    _starttime = Utils.formatTime(time.adminTime, 'HH:mm');
                    break;
                }
            }
            _endtime = Utils.formatTime(arr[arr.length - 1].adminTime, 'HH:mm');

            let st = this.startDateTime ? this.startDateTime.split(' ') : null;
            let et = this.endDateTime ? this.endDateTime.split(' ') : null;

            let stime = st !== null ? st[0] + ' ' + _starttime : this.DateandTimeUpdated;
            let etime = et !== null ? et[0] + ' ' + _endtime : this.DateandTimeUpdated;

            this.startDateTime = Utils.formatterDateTimeToString(
                Utils.formatDateTime(stime, Utils.getDateTimeFormat())
            );
            this.endDateTime = Utils.formatterDateTimeToString(
                Utils.formatDateTime(etime, Utils.getDateTimeFormat())
            );
        },

        async ValidateIsPrescriptionCurrent() {
            let result = true;
            if (this.PharmacyOption && this.PharmacyOption.copyActivePresc) {
                await this.getPrescriptionCurrent('WRITE');

                if (this.IsPrescriptionCurrent) {
                    await this.$bvModal
                        .msgBoxConfirm(
                            this.$t('StandingOrders.MsgPrescriptionCurrent', {
                                label: this.value.drugName
                            }),
                            {
                                title: this.$t('Medication.Medications'),
                                okTitle: this.$t('Shared.Continue'),
                                cancelTitle: this.$t('Shared.BtnCancel'),
                                footerClass: 'p-2',
                                titleClass: 'modal-title modal-type-warning',
                                id: 'modal_delete_vitals'
                            }
                        )
                        .then(value => (result = value));
                }
            }

            return result;
        },

        async ValidateRequired() {
            if (!this.value.selected) {
                return true;
            }

            this.isFrequencyValid = Utils.isNullOrEmptyString(this.value.frequencyCode)
                ? false
                : true;
            this.isDayValid = this.value.day <= 0 ? false : true;
            this.isDosageValid = this.value.dosage <= 0 ? false : true;
            this.isDailyAmountValid = this.value.dailyAmount <= 0 ? false : true;
            this.isStartTimeValid =
                this.startDateTime &&
                Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat(), true)
                    ? true
                    : false;
            this.isEndTimeValid =
                this.endDateTime &&
                Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat(), true)
                    ? true
                    : false;

            this.TextFrequency =
                this.value.frequencyCode === ''
                    ? this.$t('Msg.RequiredField')
                    : this.$t('Medication.InvalidFrequency');
            this.startTimeValidMessage = this.startDateTime ? this.$t('Shared.InvalidDate') : null;
            this.endTimeValidMessage = this.endDateTime ? this.$t('Shared.InvalidDate') : null;

            this.isDiagnosisValid = true;
            if (this.PharmacyOption.enforceDiagnosis) {
                this.isDiagnosisValid = !Utils.isNullOrEmptyString(this.value.diagCode);
            }

            this.isActionValid = true;
            if (this.PharmacyOption.enforceSigAction) {
                this.isActionValid = !Utils.isNullOrEmptyString(this.value.actionCode);
            }

            this.isRouteValid = true;
            if (this.PharmacyOption.enforceSigRoute) {
                this.isRouteValid = !Utils.isNullOrEmptyString(this.value.routeCode);
            }

            this.isReasonValid = true;
            if (this.PharmacyOption.enforceSigReasonPRN && this.frecuencyMode === 'PRN') {
                this.isReasonValid = !Utils.isNullOrEmptyString(this.value.reasonCode);
            }

            const result =
                this.isFrequencyValid &&
                this.isDayValid &&
                this.isActionValid &&
                this.isDiagnosisValid &&
                this.isRouteValid &&
                this.isDosageValid &&
                this.isDailyAmountValid &&
                this.isStartTimeValid &&
                this.isEndTimeValid &&
                this.isReasonValid;
            this.value.isValidateRequired = result;
            this.value.errorMessage = null;
            this.$emit('input', this.value);
            return result;
        },

        PrepareMedication() {
            return {
                DrugCode: this.value.drugCode,
                DrugName: this.value.drugName,
                Usage: this.value.usage,
                IsPatientOwnMedication: this.value.isPatientOwnMedication,
                Day: this.value.day,
                Dosage: this.value.dosage,
                DailyAmount: this.value.dailyAmount,
                QuantityOrdered: this.value.quantityOrdered,
                StartDateTime: Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                EndDateTime: Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                RxStatus: this.value.rxStatus,
                FrequencyCode: this.value.frequencyCode,
                Sig: this.value.sig,
                Action: this.ModelAction.code,
                Route: this.ModelRoute.code,
                WhenSig: this.ModelWhen.code,
                Reason: this.ModelReason.code,
                PrescriberNotes: this.value.prescriberNotes,
                DiagCode: this.value.diagCode,
                IndicationCode: this.value.indicationCode,
                Form: this.value.form,
                MarsTimes: this.value.marsTimes
            };
        },

        initialize() {
            if (this.value) {
                if (!Utils.isNullOrEmptyString(this.value.actionCode)) {
                    const action = this.ActionList.find(
                        x => x.code.toUpperCase() == this.value.actionCode.toUpperCase()
                    );
                    if (action) {
                        this.ModelAction.code = action.code;
                        this.ModelAction.description = action.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.routeCode)) {
                    const route = this.RouteNameList.find(
                        x => x.code.toUpperCase() == this.value.routeCode.toUpperCase()
                    );
                    if (route) {
                        this.ModelRoute.code = route.code;
                        this.ModelRoute.description = route.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.whenSigCode)) {
                    const whenSign = this.WhenList.find(
                        x => x.code.toUpperCase() == this.value.whenSigCode.toUpperCase()
                    );
                    if (whenSign) {
                        this.ModelWhen.code = whenSign.code;
                        this.ModelWhen.description = whenSign.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.reasonCode)) {
                    const reason = this.ReasonList.find(
                        x => x.code.toUpperCase() == this.value.reasonCode.toUpperCase()
                    );
                    if (reason) {
                        this.ModelReason.code = reason.code;
                        this.ModelReason.description = reason.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.diagCode)) {
                    const diagnosis = this.DiagnosisList.find(
                        x => x.code.toUpperCase() == this.value.diagCode.toUpperCase()
                    );
                    if (diagnosis) {
                        this.ModelDiagnosis.code = diagnosis.code;
                        this.ModelDiagnosis.description = diagnosis.description;
                    }
                }

                if (!Utils.isNullOrEmptyString(this.value.indicationCode)) {
                    const indication = this.IndicationsList.find(
                        x => x.code.toUpperCase() == this.value.indicationCode.trim().toUpperCase()
                    );
                    if (indication) {
                        this.ModelIndication.code = indication.code;
                        this.ModelIndication.description = indication.description;
                    }
                }

                if (Utils.isNullOrEmptyString(this.value.usage)) {
                    const usage = this.UsageList.find(x => x.value.toUpperCase() == 'INTERNAL');
                    if (usage) {
                        this.ModelUsage.value = usage.value;
                        this.ModelUsage.name = usage.name;
                        this.value.usage = usage.value;
                        this.$emit('input', this.value);
                    }
                } else {
                    const usage = this.UsageList.find(
                        x => x.value.toUpperCase() == this.value.usage.trim().toUpperCase()
                    );
                    if (usage) {
                        this.ModelUsage.value = usage.value;
                        this.ModelUsage.name = usage.name;
                    }
                }

                this.CopyDateTime = Utils.formatterDateTimeToString(this.value.startDateTime);
                this.startDateTime = Utils.formatterDateTimeToString(this.value.startDateTime);
                this.endDateTime = Utils.formatterDateTimeToString(this.value.endDateTime);
                this.frecuencyMode = this.value.mode;

                if (this.frecuencyMode !== 'STAT' && this.frecuencyMode !== 'PRN') {
                    this.getMarsTimes();
                }
            }
        },

        setPendingChanges(value) {
            this.pendingChanges = value;
        },

        getPendingChanges() {
            return this.pendingChanges;
        },

        onIsValidChangeStartDateTime(value) {
            this.isStartTimeValid = value.isValid;
            this.startTimeValidMessage = value.invalidFeedback;
        },

        onIsValidChangeEndDateTime(value) {
            this.isEndTimeValid = value.isValid;
            this.endTimeValidMessage = value.invalidFeedback;
        },

        toggleSelectState() {
            this.value.selected = !this.value.selected;
            if (!this.value.selected) {
                this.value.isValidateRequired = true;
                this.value.errorMessage = null;
            }

            this.$emit('input', this.value);
        },

        setIsValidateRequired(value, errorMessage) {
            if (this.value.selected) {
                this.value.isValidateRequired = value;
                this.value.errorMessage = errorMessage;
                this.$emit('input', this.value);
            }
        },

        async getPrescriptionCurrent(Action) {
            const params = {
                PatientCode: this.$route.params.id,
                DrugCode: this.value.drugCode,
                Mode: this.frecuencyMode,
                RecordId: this.$route.params.recordid,
                Action: Action,
                StartDateTime: Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                EndDateTime: Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                Day: this.value.day
            };

            this.IsPrescriptionCurrent = false;
            await MedicationService.IsPrescriptionCurrent(params)
                .then(response => {
                    if (response.status == '200') {
                        this.IsPrescriptionCurrent = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    mounted() {
        this.initialize();
    }
};
</script>

<style scoped>
.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img {
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0)
    );
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
}

.carouselPic {
    background-color: #fff !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19bee1;
    overflow: hidden;
}
.carouselPic .carousel-item {
    background-color: #fff !important;
}
.patPhoto .carousel-description {
    color: white !important;
    background-color: #19bee1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon {
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed {
    position: absolute;
    top: 5px;
    right: 25px;
}
</style>
